import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { comEnum, componentBaseData } from '../enum';
import { v4 as uuidv4 } from 'uuid';
export default {
  props: {
    formItems: {
      default: function _default() {
        return [];
      }
    },
    title: {
      default: ''
    }
  },
  data: function data() {
    return {
      // 组件列表
      comEnum: comEnum,
      // 当前选中ID
      currentCom: '',
      // 目标元素ID
      currentOver: ''
      // formItems: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    // 初始化默认选中第一项
    setTimeout(function () {
      var item = _this.formItems[0];
      _this.currentCom = item.id;
      _this.$emit('active', item);
      _this.$emit('changeViewCtrl', true);
    });
  },
  methods: {
    // handlClick() {
    //   // console.log(JSON.stringify(this.formItems))
    // },
    // 拖放结束添加
    handleDrop: function handleDrop(event) {
      event.stopPropagation();
      var type = +event.dataTransfer.getData('type');
      if (!type) return false;
      this.currentCom = uuidv4(); //  Date.now() + Math.random()
      var item = {
        id: this.currentCom,
        type: type,
        rule: true,
        attribute: componentBaseData.get(type)()
      };
      this.formItems.push(item);
      this.$emit('active', item);
      this.$emit('changeViewCtrl', true);
      this.currentOver = '';
    },
    // 组件内拖拽开始
    handleDragStart: function handleDragStart(event, index) {
      event.dataTransfer.setData('index', index);
    },
    // 拖拽过程
    handleOver: function handleOver(event, id) {
      this.currentOver = id;
    },
    handleDragend: function handleDragend() {
      this.currentOver = '';
    },
    // 拖拽结束
    handleItemDrop: function handleItemDrop(event, index) {
      event.stopPropagation();
      // 清空悬浮样式
      this.currentOver = '';
      // 首先获取将要换位的组件
      // 注意这里paramIndex值可能为0
      var paramIndex = event.dataTransfer.getData('index');
      var type = +event.dataTransfer.getData('type');
      var item;
      // 这里区分插入或者换位
      if (paramIndex) {
        item = this.formItems.splice(paramIndex, 1)[0];
        this.formItems.splice(index, 0, item);
      }
      if (type) {
        item = {
          id: uuidv4(),
          type: type,
          rule: true,
          attribute: componentBaseData.get(type)()
        };
        this.formItems.splice(index, 0, item);
      }
      // 展示属性详情
      this.currentCom = item.id;
      this.$emit('active', item);
      this.$emit('changeViewCtrl', true);
    },
    // 当前组件ID
    handleClick: function handleClick(item) {
      this.currentCom = item.id;
      this.$emit('active', item);
    },
    // 删除组件
    handleDel: function handleDel(index) {
      this.formItems.splice(index, 1);
    }
  }
};